module.exports = __webpack_public_path__ + "img/bg-budgetform.6bab053d.png";